/* eslint-disable */
import { produce } from "immer";
import {
  RA_CMS_FUNDS_FETCH_START,
  RA_CMS_FUNDS_FETCH_SUCCESS,
  RA_CMS_FUNDS_FETCH_FAILURE,
} from "../actions/types";

const raCMSFunds = (
  state = {
    raCMSFundsFetching: false,
    raCMSFundsData: [],
    raCMSFundsError: null,
  },
  action,
) => {
  switch (action.type) {
    case RA_CMS_FUNDS_FETCH_START:
      return produce(state, (draft) => {
        draft.raCMSFundsFetching = true;
      });
    case RA_CMS_FUNDS_FETCH_SUCCESS:
      return produce(state, (draft) => {
        draft.raCMSFundsFetching = true;
        draft.raCMSFundsData = action.data;
        draft.raCMSFundsFetching = false;
      });
    case RA_CMS_FUNDS_FETCH_FAILURE:
      return produce(state, (draft) => {
        draft.raCMSFundsFetching = false;
        draft.raCMSFundsError = action.error;
      });
    default:
      return state;
  }
};

export default raCMSFunds;
